import { render, staticRenderFns } from "./DashLogo.vue?vue&type=template&id=02719d80&scoped=true&"
import script from "./DashLogo.vue?vue&type=script&lang=ts&"
export * from "./DashLogo.vue?vue&type=script&lang=ts&"
import style0 from "./DashLogo.vue?vue&type=style&index=0&id=02719d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02719d80",
  null
  
)

export default component.exports